import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const powerBi = defineConnector({
  identifier: "powerBi",
  name: "Power BI",
  tagLine: "Business analytics platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.powerbi\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Register an app for Power BI",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Azure portal](https://portal.azure.com/), register an app in Microsoft Entra ID, create a client secret, and configure the service principal to access the Power BI workspaces your integration needs.",
        },
      ],
    },
    {
      title: "Enter your Power BI credentials",
      items: [
        {
          kind: "input",
          label: "Tenant ID",
          required: true,
          placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          target: { kind: "configuration", field: "tenantId" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
          helperText: "Use the Microsoft Entra application (client) ID.",
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
          helperText:
            "Use the client secret you created for the Microsoft Entra app.",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenantId }) =>
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    scopes: () => ["https://analysis.windows.net/powerbi/api/.default"],
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.powerbi.com/v1.0/myorg/groups",
      expectedStatus: [200, 403],
    }),
  },
});
